module.exports = __webpack_public_path__ + "img/about5.9a1996cb.png";